import React, { useEffect } from 'react'
import HeaderImage from '../../img/programmers-header-reverse.svg'
import FooterImage from '../../img/programmers-footer.svg'
import { Container } from '@material-ui/core'
import { Helmet } from 'react-helmet'


const Programmers = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })
    
    return (
        <>
            <Helmet>
                <title>منم ، هویت دیجیتالی تو - برنامه نویس ها</title>
            </Helmet>

            <main id="programmers">

                <section id='section-1'>
                    <img src={HeaderImage} alt='' />
                </section>

                <Container maxWidth='md'>
                    <section id="section-2">
                        <h2>مَنَم، آی-دس !</h2>
                        <p>احراز هویت به عنوان یک سرویس یا IDaaS شامل روش‌های مدیریتِ هویت و دسترسی از طریق فضای ابری است. اگر در حال توسعه‌ی یک نرم افزار، اپلیکیشن یا سایتی هستید که با حجم زیادی از اطلاعات مشتریان سر و کار دارد، سرویس احراز هویت به شما کمک می‌کند تا با دقت و سرعت بیشتر و همچنین هزینه کمتر، عملیات پایش مخاطبان را انجام داده و از این طریق، سرویسی امن و با کیفیت را ارائه دهید.</p>
                        <p>از طرفی مخاطبان از طریق ورود اطلاعات و ثبت نام در منم، قادر خواهند بود تا سایت‌ و اپلیکیشن‌های مختلف عضو «منم» را بدون نیاز به ثبت نام مجدد، مورد بازدید و استفاده قرار دهند. </p>
                        <p>احراز هویت به عنوان یک سرویس یا IDaaS یکی از پرکاربرد ترین سرویس‌های توسعه دهندگان و شرکت‌های نرم افزاری به شمار می‌رود. </p>
                        <strong><p>پس از رسوایی‌هایی مانند ماجرای فیسبوک، شرکت‌های زیادی به سراغ تامین کنندگان احراز هویت به عنوان یک سرویس می‌روند تا از آن‌ها برای افزایش امنیت و مدیریت آنلاین هویت‌ها کمک بگیرند.</p></strong>

                        <hr />

                        <h2>منم، چه سرویس‌هایی ارائه می‌دهد؟</h2>

                        <article>
                            <h4>سرویس ثبت نام (sign on)</h4>
                            <p>برای ورود به سایت یا اپلیکیشن شما، دیگر نیازی به ساخت «درگاه ثبت نام» و اختصاص فضای لازم برای ذخیره مشخصات نبوده و این درگاه از طریق «مَنَم» در اختیار شما قرار خواهد گرفت. ثبت نام به این صورت انجام می‌شود که اطلاعات درخواستی شما از کاربر توسط «مَنَم» دریافت و در فضای مخصوص به شما ذخیره خواهد شد.</p>
                        </article>

                        <article>
                            <h4>سرویس مشترک ورود از طریق مَنَم (Single Sign-on)</h4>
                            <p>این سرویس علاوه بر بهبود رضایت مشتری و امنیت بیشتر، سربار ناشی از شناخت مخاطبان و امنیت را نیز برای شما کاهش خواهد داد. درواقع مخاطبان سایت‌های مختلف از طریق یک درگاه ورود می‌توانند به سایت‌های مختلفی که از آن درگاه سرویس گرفته‌اند، بهره مند شده و زمان کمتری را برای ثبت نام در سایت‌های مختلف، اختصاص دهند. </p>
                        </article>
                    </section>
                </Container>

            </main>
        </>
    )
}

export default Programmers